import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, toHandlers as _toHandlers } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ConfigProvider = _resolveComponent("ConfigProvider");
  const _component_x_button = _resolveComponent("x-button");
  const _component_x_modal = _resolveComponent("x-modal");
  return _openBlock(), _createBlock(_component_x_modal, _mergeProps({
    ref: "modalRef"
  }, $setup.modalProps, {
    "show-ok-button": true,
    "show-cancel-button": true
  }, _toHandlers($setup.modalEvents)), {
    "foot-tools": _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.modalTools, (item, idx) => {
      return _openBlock(), _createBlock(_component_x_button, _mergeProps({
        key: idx
      }, {
        ref_for: true
      }, item, {
        onClick: item.onClick
      }), null, 16, ["onClick"]);
    }), 128))]),
    "foot-buttons": _withCtx(() => [_createVNode(_component_x_button, _mergeProps($setup.buttonProps.ok, _toHandlers($setup.buttonEvents.ok)), null, 16), _createVNode(_component_x_button, _mergeProps($setup.buttonProps.cancel, _toHandlers($setup.buttonEvents.cancel)), null, 16)]),
    default: _withCtx(() => [_createVNode(_component_ConfigProvider, {
      theme: $setup.appTheme,
      locale: $setup.locale,
      "component-size": $setup.componentSize
    }, {
      default: _withCtx(() => [_renderSlot(_ctx.$slots, "component", _normalizeProps(_guardReactiveProps($setup.componentParams)))]),
      _: 3
    }, 8, ["theme", "locale", "component-size"])]),
    _: 3
  }, 16);
}